import { booleanAttribute, inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {  

  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuth: boolean = authService.isAuth();

  if (isAuth) {
    return true;
  } else {
    router.navigateByUrl('/login');
    return false;
  }
};
